import PropTypes from "prop-types";
import React, {useRef, useState} from "react";
import {useIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";

import {Button, Menu, MenuItem, Tooltip, styled} from "@material-ui/core";
import {ArrowDropDown, Translate} from "@material-ui/icons";

import useToast from "src/hooks/useToast";

import {changeLanguage} from "src/actions/multiLanguageActions";

import {FCM_TOKEN_LOCAL_STORAGE} from "src/constants";
// ref: https://flagicons.lipis.dev/
import UsFlag from "src/i18n/flags/en.png";
import ViFlag from "src/i18n/flags/vi.png";
import {LOCALES} from "src/i18n/locales";
import userService from "src/services/userService";

const languageFlag = (code) => {
  switch (code) {
    case LOCALES.VIETNAMESE.code:
      return ViFlag;
    case LOCALES.ENGLISH.code:
      return UsFlag;
    default:
      return null;
  }
};

const LanguageButton = styled(Button)(() => ({
  "& .MuiButton-endIcon": {
    marginLeft: 4
  }
}));

function LangSwitching({themes}) {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const {currentLanguage} = useSelector((state) => state.multiLanguage);
  const langList = Object.keys(LOCALES);
  const moreRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const {toastErrorMessage} = useToast();

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const changeUserLanguageService = async (shortCode, fcmToken) => {
    try {
      await userService.changeUserLanguage(shortCode, fcmToken);
    } catch (error) {
      toastErrorMessage(error);
    }
  };

  const getSortCodeLang = (lang) => {
    switch (lang) {
      case LOCALES.ENGLISH.code:
        return LOCALES.ENGLISH.shortCode;
      default:
        return LOCALES.VIETNAMESE.shortCode;
    }
  };

  const handleLanguageChange = (value) => {
    dispatch(changeLanguage(value));
    setOpenMenu(false);

    const shortCode = getSortCodeLang(value);
    const fcmToken = localStorage.getItem(FCM_TOKEN_LOCAL_STORAGE);
    changeUserLanguageService(shortCode, fcmToken);
  };
  return (
    <>
      <Tooltip
        title={formatMessage({
          id: "topBar-languageSwitching-tooltip",
          defaultMessage: "Switch Languages"
        })}
      >
        <LanguageButton
          ref={moreRef}
          onClick={handleMenuOpen}
          startIcon={
            <Translate className={themes?.startIcon ?? ""} style={{fontSize: 22}} />
          }
          endIcon={
            <ArrowDropDown className={themes?.endIcon ?? ""} style={{fontSize: 22}} />
          }
          className={themes?.primaButton ?? ""}
        >
          {currentLanguage?.description}
        </LanguageButton>
      </Tooltip>
      <Menu
        style={{width: 180}}
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={moreRef.current}
        onClose={handleMenuClose}
        open={openMenu}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        {langList?.map((item) => (
          <MenuItem
            key={LOCALES[item]?.code}
            onClick={() => handleLanguageChange(LOCALES[item]?.code)}
            style={{
              ...(LOCALES[item]?.code === currentLanguage?.code
                ? {background: "rgba(0, 0, 0, 0.08)"}
                : {}),
              display: "flex",
              alignItems: "center"
            }}
          >
            <img
              alt={`flag-${item}`}
              height={18}
              src={languageFlag(LOCALES[item]?.code)}
            />
            &nbsp;
            {LOCALES[item]?.description}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

LangSwitching.propTypes = {
  themes: PropTypes.object
};

export default LangSwitching;
